<template>
  <div>
    <navbar/>
    <error-panel showInPopup="false" />
    <div v-if="!successfullyRegistered" class="mt-5 container">

      <!-- Title -->
      <div class="row text-center">
        <div class="col-12">
          <h1 class="font-weight-normal text-center">
          Welcome!
          </h1>
          <p class="mb-5 text-muted"> Please set up your account to start the trial period.</p>
        </div>
      </div>

      <form
        @submit="register($event)"
        action="/dontcare"
        class="row-container"
        method="post">

      <!-- Email -->
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="form-label-group required">
            <input
                    id="email"
                    type="text"
                    name="email"
                    :value="email"
                    readonly="true"
                    class="form-control disabled"
            />
            <label for="email">Email address</label>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="alert alert-info text-muted support-element">
            <span class="validation-icon bi bi-check-circle-fill text-success"></span>
            <small>Already filled in for you based on your waitlist signup.</small>
          </div>
        </div>
      </div>

      <!-- username -->
      <div class="row">

        <div class="col-12 col-lg-6">
          <div class="form-label-group required">
            <input
                v-model="username"
                id="username"
                name="username"
                type="text"
                class="form-control"
            />
            <label for="username">User name</label>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="alert alert-info text-muted support-element">
            <span class="validation-icon" :class="usernameValidStyle"></span>
            <small>Should only contain letters, numbers, underscores, spaces or dashes and between 3 and 50 characters.</small>
          </div>
        </div>
      </div>

      <!-- PW -->
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="form-label-group mb-3 required">
            <input
                    v-model="password"
                    id="password"
                    name="password"
                    type="password"
                    class="form-control"
            />
            <label for="password">Password</label>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="alert alert-info text-muted support-element">
            <span class="validation-icon" :class="passwordValidStyle"></span>
            <small>Should contain letters, numbers, and special characters and longer than 8 characters.</small>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="form-label-group mb-3 required">
            <input
                    v-model="password2"
                    id="password2"
                    name="password2"
                    type="password"
                    class="form-control"
            />
            <label for="password2">Confirm password</label>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="alert alert-info text-muted support-element">
            <span class="validation-icon" :class="passwordEqualStyle"></span>
            <small>Should be the same as the one above.</small>
          </div>
        </div>


      </div>

      <!-- Button -->
      <div class="row pt-4 pb-5">
        <div class="col-12 text-center">
          <button class="btn btn-cta btn-cta-large" type="submit">Finish registration</button>
        </div>
      </div>

    </form>
    </div>

    <div v-if="successfullyRegistered" class="mt-5 mb-5 container alert alert-success">
      <div class="row text-center">
        <div class="col-12 mb-3 mt-5">
          <h4 class="mb-3 font-weight-normal text-center">
            Your account has been created, {{ username }}.
          </h4>

          <div class="mb-5 mt-0">
            <span>Please sign in to continue!</span>
          </div>

          <div>
            <router-link class="btn btn-success btn-lg" to="/mybookmarks">Sign in</router-link>
          </div>
        </div>
      </div>
    </div>
    <tlfooter />
  </div>
</template>

<script>
import BackendClient from "@/rest/backend-client";
import ErrorPanel from "@/components/ErrorPanel";
import navbar from "@/components/NavBar";
import tlfooter from "@/components/Footer";

export default {
  name: "CompleteRegistration",
  head: {
    title: 'just bookmark it! - complete registration'
  },
  components: {ErrorPanel, navbar, tlfooter},
  props: ['email', 'regCode'],
  data() {
    return {
      username: "",
      password: "",
      password2: "",
      backendClient: new BackendClient(),
      successfullyRegistered: false
    }
  },
  computed: {
    passwordValidStyle() {
      if (this.password == "") {
        return "bi bi-check-circle-fill";
      }
      return this.validatePassword(this.password) ? "bi bi-check-circle-fill text-success" : "bi bi-x-circle-fill text-danger";
    },
    passwordEqualStyle() {
      if (this.password == "" || this.password2 == "") {
        return "bi bi-check-circle-fill";
      }
      return (this.password === this.password2) ? "bi bi-check-circle-fill text-success" : "bi bi-x-circle-fill text-danger";
    },
    usernameValidStyle() {
      if (this.username == "") {
        return "bi bi-check-circle-fill";
      }
      return this.validateUsername(this.username) ? "bi bi-check-circle-fill text-success" : "bi bi-x-circle-fill text-danger";
    },
  },
  methods: {
    validatePassword(password) {
      const invalidPasswordPattern = /^(.{0,7}|[^0-9]*|[^\p{L}]*|[\p{L}0-9]*)$/u;
      return !invalidPasswordPattern.test(password);
    },
    validateUsername(username) {
      const pattern = /^[\p{L}0-9 _-]{3,50}$/u;
      return pattern.test(username);
    },
    register(event) {
      event.preventDefault();
      if (this.username === "" || this.password === "" || this.password2 === "") {
        this.$store.commit("addError", "Empty username or password!");
        return;
      }

      if (!this.validateUsername(this.username)) {
        this.$store.commit("addError", "Username should only contain letters, numbers, underscores, spaces or dashes with a length between 3 and 50 characters!");
        return;
      }

      if (this.password !== this.password2) {
        this.$store.commit("addError", "Passwords are not the same!");
        return;
      }

      if (!this.validatePassword(this.password)) {
        this.$store.commit("addError", "Passwords should contain letters, numbers, and special characters with a minimum length of 8!");
        return;
      }

      this.backendClient.registerUser(this.username, this.email, this.password, this.regCode).then(() => {
        this.successfullyRegistered = true;
      });
    }
  }
}
</script>

<style scoped>
.form-label-group {
    position: relative;
    margin-bottom: 1rem;
}

.form-label-group input,
.form-label-group label {
  height: 3.125rem;
  padding: .75rem;
}
.form-label-group textarea {
    height: 5rem;
    padding-top: .75rem;
}

.form-label-group label {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  margin-bottom: 0;
  line-height: 1.5;
  color: #495057;
  pointer-events: none;
  cursor: text;
  border: 1px solid transparent;
  border-radius: .25rem;
  transition: all .1s ease-in-out;
}

.form-label-group input, .form-label-group textarea {
  padding-top: 1.25rem;
  padding-bottom: .25rem;
}

.form-label-group input ~ label, .form-label-group textarea ~ label {
  padding-top: .25rem;
  padding-bottom: .25rem;
  font-size: 12px;
  color: #777;
}

.support-element {
  margin-top: 0rem;
}

.validation-icon {
  margin-right: 1em;
  top: 1px;
  position: relative;
}

</style>